<template>
  <div class="popup z-index-10-fg confirmation small-popup add-lead-popup" ref="popupWindow" @dragenter="$refs.fileUpload.dragging = true">
    <div class="popup-content" ref="popupContent">
      <div class="popup-header">
        <h2>Add New Lead</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('closePopup')" />
        <div class="paperclip-icon" @click="$refs.fileUpload.$refs.fileUploadInput.click()">
          <img id="noHover" src="../assets/paperclip.svg" alt="" />
          <img id="hover" src="../assets/paperclip-hover.svg" alt="" />
        </div>
      </div>
      <div class="popup-body">
        <Dropdown label="Source" :options="['Call', 'Email', 'Walk In', 'Website', 'Planning Guide', 'Warranty Claim']" v-model="source" class="input-item medium-item" />
        <SearchMenu
          :options="contactMatches"
          placeholder="Search Contacts..."
          v-model="searchText"
          :class="{ 'input-item': true, 'large-item': true }"
          :invalid="showErrors && !contact"
          :clearOnFocus="true"
          @updateContact="assignContact"
          @forceOptionsUpdate="mainForceUpdate"
          @blurred="!contact ? (searchText = '') : null" />
        <div class="primary-input input-item large-item">
          <input type="text" v-model="jobName" />
          <label>Job Name</label>
        </div>
        <div class="primary-input input-item small-item">
          <input type="text" v-model="bwQuote" />
          <label>BW Quote #</label>
        </div>
        <div class="primary-input input-item small-item">
          <input type="text" v-model="amount" @blur="formatAmount()" />
          <label>Amount</label>
        </div>
        <div class="primary-input input-item xlarge-item">
          <textarea type="text" v-model="notes" rows="4" style="resize: none"></textarea>
          <label>Notes</label>
        </div>
        <Checkbox label="Delivery" v-model="hasDelivery" class="input-item xlarge-item" />
        <AddressSearch
          v-if="hasDelivery"
          :options="lookupResults"
          label="Delivery Address"
          v-model="deliveryAddress"
          :class="{ 'input-item': true, 'large-item': true, invalid: showErrors && !deliveryAddress }"
          @autofillAddress="(o) => (deliveryAddress = o.formattedAddress)"
          @clearLookup="lookupResults.length = 0" />

        <div class="primary-input input-item small-item" v-if="hasDelivery">
          <input type="date" v-model="requestedDeliveryDate" />
          <label>Requested Delivery Date</label>
        </div>

        <Dropdown
          label="Gate Code"
          :options="['', 'Yes', 'No']"
          v-model="isGateCode"
          :class="{ 'input-item': true, 'small-item': isGateCode != 'Yes', 'tiny-item': isGateCode == 'Yes', invalid: showErrors && !isGateCode }"
          v-if="hasDelivery" />

        <div class="primary-input input-item tiny-item" v-if="hasDelivery && isGateCode == 'Yes'">
          <input type="text" v-model="gateCode" />
          <label>Code</label>
        </div>

        <div class="primary-input input-item xlarge-item" v-if="hasDelivery">
          <textarea type="text" v-model="deliveryNotes" rows="4" style="resize: none"></textarea>
          <label>Delivery Notes</label>
        </div>

        <div class="file-list" v-if="fileList.length">
          <div v-for="file in fileList">
            <img src="../assets/paperclip-thumbnail.svg" />
            <span>{{ file }}</span>
          </div>
        </div>

        <FileUpload
          :isPanel="true"
          ref="fileUpload"
          @updateFileList="
            (e) => {
              fileList = e;
              calculateWindowDimensions();
            }
          " />
      </div>
      <div class="new-contact" v-if="contact?.type == 'new'">
        <h3>Add New Contact</h3>
        <div class="popup-body">
          <button class="contact-type" @click="newContact.contactType = 'company'" :class="{ selected: newContact.contactType == 'company' }"><img src="../assets/company.svg" />Company</button>
          <button class="contact-type" @click="newContact.contactType = 'individual'" :class="{ selected: newContact.contactType == 'individual' }"><img src="../assets/individual.svg" />Individual</button>
          <span style="flex: 1 0 55%"></span>

          <div :class="{ 'primary-input': true, 'input-item': true, 'large-item': true, invalid: showErrors && !newContact.firstName }" v-if="newContact.contactType == 'company'">
            <input type="text" v-model="newContact.firstName" />
            <label>Name</label>
          </div>

          <div :class="{ 'primary-input': true, 'input-item': true, 'large-item': true, invalid: showErrors && !newContact.firstName }" v-if="newContact.contactType == 'individual'">
            <input type="text" v-model="newContact.firstName" />
            <label>First Name</label>
          </div>

          <div :class="{ 'primary-input': true, 'input-item': true, 'large-item': true, invalid: showErrors && !newContact.lastName }" v-if="newContact.contactType == 'individual'">
            <input type="text" v-model="newContact.lastName" />
            <label>Last Name</label>
          </div>

          <SearchMenu
            :options="newContactCompanyMatches"
            placeholder="Search Companies..."
            v-if="newContact.contactType == 'individual'"
            v-model="newContact.companySearchText"
            :clearOnFocus="true"
            class="input-item large-item"
            @updateContact="assignNewContactCompany"
            @forceOptionsUpdate="companyForceUpdate"
            @blurred="!newContact.company ? (newContact.companySearchText = '') : null" />

          <AddressSearch :options="lookupResults" label="Street" v-model="newContact.street" class="input-item large-item" @autofillAddress="autofillAddress($event)" @clearLookup="lookupResults.length = 0" />

          <AddressSearch :options="lookupResults" label="City" v-model="newContact.city" class="input-item large-item" @autofillAddress="autofillAddress($event)" @clearLookup="lookupResults.length = 0" />

          <Dropdown label="State" :options="states" v-model="newContact.state" class="input-item large-item" />

          <AddressSearch :options="lookupResults" label="Zip Code" v-model="newContact.zip" class="input-item large-item" @autofillAddress="autofillAddress($event)" @clearLookup="lookupResults.length = 0" />

          <div class="primary-input input-item large-item">
            <input type="text" v-model="newContact.phone" @keyup="formatPhone($event)" />
            <label>Phone</label>
          </div>

          <div class="primary-input input-item large-item" v-if="newContact.contactType == 'individual'">
            <input type="text" v-model="newContact.email" />
            <label>Email</label>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <button @click="$emit('closePopup')" class="text-btn">cancel</button>
        <button :disabled="isSaving" :class="{ 'square-btn': true, saving: isSaving }" @click="save()">save<img src="../assets/spinner.svg" /></button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import Dropdown from './inputs/Dropdown.vue';
import SearchMenu from './inputs/SearchMenu.vue';
import AddressSearch from './inputs/AddressSearch.vue';
import Checkbox from './inputs/Checkbox.vue';
import useCompaniesQuery from '@/composables/useCompaniesQuery';
import useContactsQuery from '@/composables/useContactsQuery';
import useAlerts from '@/composables/useAlerts';
import useLeadMutate from '@/composables/useLeadMutate';
import useDecryptSymbols from '@/composables/useDecryptSymbols';
import useCurrentUser from '@/composables/useCurrentUser';
import useAddressLookup from '@/composables/useAddressLookup';
import FileUpload from './FileUpload.vue';
import useStatesAndCountries from '@/composables/useStatesAndCountries';
import useSearchWorker from '@/composables/useSearchWorker';

export default {
  name: 'AddLead',
  emits: ['closePopup'],
  components: {
    Dropdown,
    SearchMenu,
    AddressSearch,
    FileUpload,
    Checkbox,
  },
  props: {
    initContactId: {
      type: Object,
      required: false,
      default: null,
    },
  },
  setup() {
    const { addAlert } = useAlerts();
    const { addLead } = useLeadMutate();
    const { encryptSymbols } = useDecryptSymbols();
    const { user } = useCurrentUser();
    const { addressLookup, lookupResults } = useAddressLookup();
    const { stateAbbreviations } = useStatesAndCountries();

    // Set up search workers for main contact search (companies + contacts)
    const { searchResults: mainSearchResults, searchText: mainSearchText, forceUpdate: mainForceUpdate, type: mainSearchType, excludeInactive: mainExcludeInactive } = useSearchWorker();
    mainSearchType.value = 'all';
    mainExcludeInactive.value = true;

    // Set up search worker for new contact company search (companies only)
    const { searchResults: companySearchResults, searchText: companySearchText, forceUpdate: companyForceUpdate, type: companySearchType } = useSearchWorker();
    companySearchType.value = 'companies';

    return {
      companies: useCompaniesQuery.companies,
      contacts: useContactsQuery.contacts,
      addAlert,
      addLead,
      encryptSymbols,
      user,
      addressLookup,
      lookupResults,
      stateAbbreviations,
      mainSearchResults,
      mainSearchText,
      mainForceUpdate,
      companySearchResults,
      companySearchText,
      companyForceUpdate,
    };
  },
  data() {
    return {
      source: 'Walk In',
      notes: '',
      bwQuote: '',
      amount: '$',
      jobName: '',
      deliveryAddress: '',
      contact: null,
      searchText: '',
      isSaving: false,
      showErrors: false,
      hasDelivery: false,
      requestedDeliveryDate: '',
      isGateCode: '',
      gateCode: '',
      deliveryNotes: '',
      fileList: [],
      newContact: {
        firstName: '',
        lastName: '',
        company: null,
        street: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        email: '',
        contactType: 'company',
        companySearchText: '',
      },
    };
  },
  computed: {
    states() {
      return this.stateAbbreviations;
    },

    contactMatches() {
      // Add the "Add New Contact" option at the top
      const matches = [
        {
          text: 'Add New Contact',
          value: '',
          type: 'new',
        },
      ];

      // Add search results from the worker
      matches.push(...this.mainSearchResults);

      // Limit to 7 total results (including "Add New Contact")
      return matches.slice(0, 7);
    },

    newContactCompanyMatches() {
      // Return company search results directly
      return this.companySearchResults.slice(0, 6);
    },
  },
  methods: {
    assignContact(contact) {
      this.contact = contact;
      if (contact) this.searchText = contact.text;
    },
    assignNewContactCompany(company) {
      this.newContact.company = company;
      if (company) this.newContact.companySearchText = company.text;
    },
    formatPhone(event) {
      const input = event.target;
      const { value } = input;
      const numbers = value.replace(/\D/g, '');
      const char = { 0: '(', 3: ') ', 6: '-' };
      input.value = '';
      for (let i = 0; i < numbers.length; i++) {
        input.value += (char[i] || '') + numbers[i];
      }
    },
    verifyFields() {
      if (!this.contact) {
        this.addAlert('Please select a contact', 'high', 4);
        this.showErrors = true;
        return false;
      } else if (this.contact?.type == 'new') {
        if (this.newContact.contactType == 'company' && !this.newContact.firstName) {
          this.addAlert('Please fill out all required fields', 'high', 4);
          this.showErrors = true;
          return false;
        } else if (this.newContact.contactType == 'individual' && (!this.newContact.firstName || !this.newContact.lastName)) {
          this.addAlert('Please fill out all required fields', 'high', 4);
          this.showErrors = true;
          return false;
        }
      }

      if (this.hasDelivery && !this.deliveryAddress) {
        this.addAlert('Please fill out the site address', 'high', 4);
        this.showErrors = true;
        return false;
      }

      if (this.hasDelivery && !this.isGateCode) {
        this.addAlert('Please select if there is a gate code', 'high', 4);
        this.showErrors = true;
        return false;
      }

      this.showErrors = false;
      return true;
    },
    async save() {
      if (!this.verifyFields()) return;
      this.isSaving = true;
      const leadToSave = {
        SOURCE: this.source,
        NOTES: this.notes,
        BWQUOTE: this.bwQuote,
        JOBNAME: this.jobName,
        AMOUNT: this.amount.replace(/[^0-9.]/g, ''),
        ASSIGNEDID: this.user.userid,
      };

      if (this.hasDelivery) {
        leadToSave.HASDELIVERY = true;
        leadToSave.DELIVERYADDRESS = this.deliveryAddress;
        leadToSave.DELIVERYDATE = new Date(this.requestedDeliveryDate).getTime().toString();
        leadToSave.GATECODE = this.isGateCode ? this.gateCode : null;
        leadToSave.DELIVERYNOTES = this.deliveryNotes;
      } else {
        leadToSave.HASDELIVERY = false;
      }

      if (this.contact?.type == 'contact') {
        leadToSave.CONTACTID = this.contact.value;
      } else if (this.contact?.type == 'company') {
        leadToSave.COMPANYID = this.contact.value;
      } else if (this.contact.type == 'new') {
        if (this.newContact.contactType == 'company') {
          leadToSave.company = {
            NAME: this.newContact.firstName,
            CATEGORY: 'Customer',
            address: {
              LINE1: this.newContact.street,
              POSTALCODE: this.newContact.zip,
              STATE: this.newContact.state,
              CITY: this.newContact.city,
            },
            phones: [
              {
                NUMBERDISPLAY: this.newContact.phone,
                TYPEID: 'C3AE9586-6158-4D0D-9FAF-253CB0152F18',
              },
            ],
          };
        } else {
          leadToSave.contact = {
            FIRSTNAME: this.newContact.firstName,
            LASTNAME: this.newContact.lastName,
            COMPANYID: this.newContact.company?.value,
            CATEGORY: 'Customer',
            address: {
              LINE1: this.newContact.street,
              POSTALCODE: this.newContact.zip,
              STATE: this.newContact.state,
              CITY: this.newContact.city,
            },
            email: {
              ADDRESS: this.newContact.email,
            },
            phones: [
              {
                NUMBERDISPLAY: this.newContact.phone,
                TYPEID: 'C3AE9586-6158-4D0D-9FAF-253CB0152F18',
              },
            ],
          };
        }
      }

      const encryptedLead = this.encryptSymbols(leadToSave);

      const newID = await this.addLead(encryptedLead);
      if (!newID) {
        this.isSaving = false;
        return;
      }

      await this.$refs.fileUpload.uploadFiles(newID.addLead);

      this.isSaving = false;
      this.addAlert('New lead has been created.', 'low', 3);
      this.$emit('closePopup');
    },
    formatAmount() {
      let newAmount = this.amount.replace(/[^0-9.]/g, '');
      if (newAmount.length == 0) {
        this.amount = '$';
        return;
      }
      newAmount = newAmount.replace(/\.(?=.*\.)/g, '');
      if (newAmount.includes('.') && newAmount.split('.')[1].length == 0) newAmount += '00';
      if (newAmount.includes('.') && newAmount.split('.')[1].length == 1) newAmount += '0';
      if (newAmount.includes('.') && newAmount.split('.')[1].length > 2) {
        newAmount = newAmount.replace(/\./g, '');
        newAmount = newAmount.slice(0, -2) + '.' + newAmount.slice(-2);
      }
      if (newAmount.startsWith('.')) newAmount = '0' + newAmount;
      if (!newAmount.includes('.')) {
        newAmount += '.00';
      }
      if (newAmount == '.00') newAmount = '0.00';
      if (newAmount.match(/^0+(?!\.|$)/)) {
        newAmount = newAmount.replace(/^0+(?!\.|$)/, '');
      }
      newAmount = '$' + newAmount;

      this.amount = newAmount;
    },
    calculateWindowDimensions() {
      this.$nextTick(() => {
        const newHeight = this.$refs.popupContent.scrollHeight + 'px';
        this.$refs.popupWindow.style.height = newHeight;
      });
    },
    autofillAddress(option) {
      if (option.address) this.newContact.street = option.address;
      if (option.city) this.newContact.city = option.city;
      if (option.state) this.newContact.state = option.state;
      if (option.zip) this.newContact.zip = option.zip;
    },
    updateAddressLookup(addressType) {
      if (addressType == 'deliveryAddress') {
        this.addressLookup(this.deliveryAddress);
      } else if (addressType == 'newContactAddress') {
        if (this.newContact.street && this.newContact.city && this.newContact.state && this.newContact.zip) return;
        this.addressLookup(this.newContact.street, this.newContact.city, this.newContact.state, this.newContact.zip);
      }
    },
  },
  watch: {
    searchText() {
      this.mainSearchText = this.searchText;
    },
    'newContact.companySearchText'() {
      this.companySearchText = this.newContact.companySearchText;
    },
    'newContact.street'() {
      this.updateAddressLookup('newContactAddress');
    },
    'newContact.city'() {
      this.updateAddressLookup('newContactAddress');
    },
    'newContact.state'() {
      this.updateAddressLookup('newContactAddress');
    },
    'newContact.zip'() {
      this.updateAddressLookup('newContactAddress');
    },
    deliveryAddress() {
      this.updateAddressLookup('deliveryAddress');
    },
  },
  mounted() {
    this.calculateWindowDimensions();

    if (this.initContactId?.type && this.initContactId?.entityid) {
      if (this.initContactId.type == 'company') {
        const company = this.companies.find((company) => company.COMPANYID.toUpperCase() == this.initContactId.entityid.toUpperCase());
        if (company) this.assignContact({ text: company.NAME, value: company.COMPANYID, type: 'company' });
      } else if (this.initContactId.type == 'contact') {
        const contact = this.contacts.find((contact) => contact.CONTACTID.toUpperCase() == this.initContactId.entityid.toUpperCase());
        if (contact) this.assignContact({ text: (contact.FIRSTNAME + ' ' + contact.LASTNAME).trim(), value: contact.CONTACTID, type: 'contact' });
      }
    }
  },
  updated() {
    this.$refs.popupWindow.style.transition = 'height 0.5s ease';
    this.calculateWindowDimensions();
  },
};
</script>

<style lang="scss" scoped>
.add-lead-popup {
  width: 65rem;
  max-width: 80vw;
  max-height: 90vh;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  /*transition: height 0.5s ease;*/

  .popup-body {
    display: flex;
    flex-direction: row;
    margin-top: 2rem !important;
    flex-wrap: wrap;
    gap: 1.5rem 1rem;

    .input-item {
      &.tiny-item {
        min-width: 3rem;
        max-width: 5.5rem;
        flex: 1 0 4%;
      }

      &.small-item {
        min-width: 5rem;
        max-width: 12rem;
        flex: 1 0 8%;
      }

      &.medium-item {
        min-width: 8rem;
        max-width: 15rem;
        flex: 1 0 18%;
      }

      &.large-item {
        min-width: 18rem;
        flex: 1 0 28%;
      }

      &.xlarge-item {
        min-width: 20rem;
        flex: 1 0 90%;
      }
    }

    .contact-type {
      color: black;
      background: #fcfcfc;
      border: $tableBorderColor solid 1px;
      border-radius: $borderRadius4;
      padding: 0.9rem 1rem;
      margin-right: 1rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      font-size: $fontSize16;

      img {
        margin-right: 0.8rem;
        width: 1.3rem;
      }

      &.selected {
        border: $primaryActionColor solid 1px;
        box-shadow: 0px 0px 2px 0px #2a4b7c80;

        img {
          filter: brightness(0) saturate(100%) invert(26%) sepia(62%) saturate(484%) hue-rotate(176deg) brightness(98%) contrast(101%);
        }
      }
    }
  }
}
</style>
